/* eslint-disable import/no-unresolved */
import {
  ChevronDown,
  Cpu,
  File,
  Globe,
  HandCoins,
  Map,
  MemoryStick,
  Server,
  Users,
  Video,
} from 'lucide-react';
import { useRef, useState } from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

const Compare7 = () => {
  const detailsRef = useRef<HTMLDetailsElement>(null);
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    const el = detailsRef.current;
    if (el) {
      const isOpen = el.open;
      setOpen(isOpen);
      if (isOpen) {
        setTimeout(
          () => el.scrollIntoView({ behavior: 'smooth', block: 'start' }),
          0,
        );
      }
    }
  };

  return (
    <>
      <details
        ref={detailsRef}
        onToggle={handleToggle}
        className="mx-auto mb-2 block w-fit"
      >
        <summary className="text-md mx-auto flex cursor-pointer items-center justify-between font-light text-primary">
          <span>View product specifications </span>
          <ChevronDown
            className={`transition-transform duration-200 ${
              open ? 'rotate-180' : ''
            }`}
          />
        </summary>
      </details>

      {open && (
        <section className="py-8">
          <div className="container">
            <div className="mx-auto max-w-3xl overflow-x-auto px-6 py-4">
              <Table className="rounded border text-left shadow-lg">
                <TableHeader>
                  <TableRow>
                    <TableHead />
                    <TableHead className="bg-[#11171F] px-6 py-4 font-semibold text-white">
                      Our Service
                    </TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody className="text-foreground">
                  <TableRow>
                    <TableCell className="px-6 py-4 font-medium">
                      <Server className="inline w-4"></Server> Server
                      Availability
                    </TableCell>
                    <TableCell className="bg-[#11171F] px-6 py-4 text-white">
                      24/7 Private Server
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="px-6 py-4 font-medium">
                      <File className="mt-[-2px] inline w-4"></File> Plugins
                    </TableCell>
                    <TableCell className="bg-[#11171F] px-6 py-4 text-white">
                      Packed with Scrim, Practice, Retake, and More – Premium
                      Features!
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="px-6 py-4 font-medium">
                      <Map className="mt-[-2px] inline w-4"></Map> 2D Replay
                    </TableCell>
                    <TableCell className="bg-[#11171F] px-6 py-4 text-white">
                      Multi-Game, Filters,
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="px-6 py-4 font-medium">
                      <Globe className="mt-[-2px] inline w-4"></Globe> Global
                      Reach
                    </TableCell>
                    <TableCell className="bg-[#11171F] px-6 py-4 text-white">
                      28 Locations Worldwide for Low-Latency
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="px-6 py-4 font-medium">
                      <MemoryStick className="mt-[-2px] inline w-4"></MemoryStick>{' '}
                      Memory
                    </TableCell>
                    <TableCell className="bg-[#11171F] px-6 py-4 text-white">
                      High-Performance 32GB DDR4 ECC
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="px-6 py-4 font-medium">
                      <Cpu className="mt-[-2px] inline w-4"></Cpu> Processing
                      Power
                    </TableCell>
                    <TableCell className="bg-[#11171F] px-6 py-4 text-white">
                      Cutting-Edge AMD EPYC 7443, 9754, or Ryzen 7950X3
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="px-6 py-4 font-medium">
                      <Users className="mt-[-2px] inline w-4"></Users> Player
                      Access
                    </TableCell>
                    <TableCell className="bg-[#11171F] px-6 py-4 text-white">
                      Up to 7 Players for Team Play
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="px-6 py-4 font-medium">
                      <Video className="mt-[-2px] inline w-4"></Video> FACEIT
                      Demos
                    </TableCell>
                    <TableCell className="bg-[#11171F] px-6 py-4 text-white">
                      Instant Availability
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="px-6 py-4 font-medium">
                      <HandCoins className="mt-[-2px] inline w-4"></HandCoins>{' '}
                      Refund
                    </TableCell>
                    <TableCell className="bg-[#11171F] px-6 py-4 text-white">
                      7 day money-back guarantee
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export { Compare7 };
